/**
 * @desc 派发action Key
 */

function keyMirror(obj) {
  if (obj instanceof Object) {
    let _obj = Object.assign({}, obj)
    let _keyArray = Object.keys(obj)
    _keyArray.forEach(key => (_obj[key] = key))
    return _obj
  }
}

export const types = keyMirror({
  // 更新客户端数据
  UPDATE_CLIENT_INFO: null,
  // 更新用户数据
  UPDATE_USER_INFO: null,
  // 设置重新支付的支付方式
  SET_SECOND_PAYMETHOD_LIST: null,
  // 设置重新支付的选中支付方式
  SELECT_SECOND_PAYMENT: null,
  // 获取优惠券列表信息
  UPDATE_COUPON_LIST: null,
  // 更新商品可领取优惠券
  UPDATE_PRODUCT_AVALIABLE_COUPON_LIST: null,
  // 重置可使用优惠券列表
  RESET_COUPON_LIST: null,
  // 重置优惠券列表
  UPDATE_PRODUCT_RESET_COUPON_LIST: null,
  // 默认最大优惠券选中
  COUNT_MAX_COUPON_INFO: null,
  // 充值商品可领取优惠券
  RESET_PRODUCT_AVALIABLE_COUPON_LIST: null,
  // 当前商品的优惠券（未领取及已领取）
  RECEIVE_COUPON_LIST: null,
  // 更新可领取优惠券状态
  UPDATE_RECEIVED_COUPON_STATE: null
  // 更新订单列表
  , UPDATE_ORDER_LIST: null
  // 清空订单列表
  , CLEAR_ORDER_LIST: null
  // 更新sku列表（营销系统）
  , UPDATE_SKU_LIST: null
  // 选中sku下标
  , SELECT_SKU_INDEX: null
  // 更新支付方式
  , SET_PAYMETHOD_LIST: null
  // 选择支付方式
  , SELECT_PAYMENT: null
  // 单品详情
  , SET_SKU_DETAIL: null
  // 更新优惠券
  , UPDATE_SUBIMT_COUPON: null
  // 更新环境
  , UPDATE_ENV: null
})
